'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_TRANSFORMERS = exports.RESPONSE_TRANSFORMERS = exports.REQUEST_TRANSFORMERS = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _typeof2 = require('babel-runtime/helpers/typeof');
var _typeof3 = _interopRequireDefault(_typeof2);
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.makeRequest = makeRequest;
var _crossFetch = require('cross-fetch');
var _crossFetch2 = _interopRequireDefault(_crossFetch);
var _methods = require('methods');
var _methods2 = _interopRequireDefault(_methods);
var _qs = require('qs');
var _qs2 = _interopRequireDefault(_qs);
var _ResponseError = require('./ResponseError');
var _ResponseError2 = _interopRequireDefault(_ResponseError);
var _retry = require('./retry');
var _retry2 = _interopRequireDefault(_retry);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var REQUEST_TRANSFORMERS = exports.REQUEST_TRANSFORMERS = {
  'application/json': function applicationJson(body) {
    try {
      return JSON.stringify(body);
    } catch (e) {
      return body;
    }
  }
};
var RESPONSE_TRANSFORMERS = exports.RESPONSE_TRANSFORMERS = {
  'application/json': function applicationJson(response) {
    return response.json();
  }
};
var ERROR_TRANSFORMERS = exports.ERROR_TRANSFORMERS = {};
function checkStatus(response) {
  if (response.ok) {
    return response;
  } else {
    if (response.text) {
      return response.text().then(function (text) {
        var error = new _ResponseError2.default({
          status: response.status,
          text: text,
          response: response,
          url: response.url
        });
        throw error;
      });
    }
    throw response;
  }
}
function handleTransformer(key, transformers, obj) {
  var transformerKey = Object.keys(transformers).find(function (objKey) {
    return key && key.includes(objKey);
  });
  var transformer = transformers[transformerKey];
  if (transformer) return transformer(obj);
  return obj;
}
function buildTransformer(userDefinedTransformers, globalTransformers) {
  return (0, _extends3.default)({}, globalTransformers, userDefinedTransformers);
}
function makeRequest(_ref) {
  var _ref$url = _ref.url,
    url = _ref$url === undefined ? '' : _ref$url,
    _ref$method = _ref.method,
    method = _ref$method === undefined ? 'GET' : _ref$method,
    _ref$queryParameters = _ref.queryParameters,
    queryParameters = _ref$queryParameters === undefined ? {} : _ref$queryParameters,
    body = _ref.body,
    _ref$headers = _ref.headers,
    headers = _ref$headers === undefined ? {} : _ref$headers,
    contentType = _ref.contentType,
    accept = _ref.accept,
    _ref$credentials = _ref.credentials,
    credentials = _ref$credentials === undefined ? 'include' : _ref$credentials,
    _ref$mode = _ref.mode,
    mode = _ref$mode === undefined ? 'cors' : _ref$mode,
    _ref$redirect = _ref.redirect,
    redirect = _ref$redirect === undefined ? 'follow' : _ref$redirect,
    _ref$cache = _ref.cache,
    cache = _ref$cache === undefined ? 'default' : _ref$cache,
    _ref$referrer = _ref.referrer,
    referrer = _ref$referrer === undefined ? 'client' : _ref$referrer,
    integrity = _ref.integrity,
    _ref$follow = _ref.follow,
    follow = _ref$follow === undefined ? 20 : _ref$follow,
    _ref$compress = _ref.compress,
    compress = _ref$compress === undefined ? true : _ref$compress,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === undefined ? 0 : _ref$timeout,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 0 : _ref$size,
    _ref$agent = _ref.agent,
    agent = _ref$agent === undefined ? null : _ref$agent,
    requestTransformers = _ref.requestTransformers,
    responseTransformers = _ref.responseTransformers,
    errorTransformers = _ref.errorTransformers,
    retryMax = _ref.retryMax,
    retryBackoff = _ref.retryBackoff;
  if (!_methods2.default.includes(method.toLowerCase())) {
    throw new Error('Unsupported HTTP method');
  }
  if ((typeof queryParameters === 'undefined' ? 'undefined' : (0, _typeof3.default)(queryParameters)) !== 'object' || queryParameters === undefined) {
    throw new Error('Query parameters must be provided as JSON object.');
  }
  if ((typeof headers === 'undefined' ? 'undefined' : (0, _typeof3.default)(headers)) !== 'object' || headers === undefined) {
    throw new Error('Headers must be provided as JSON object.');
  }
  if ((typeof body === 'undefined' ? 'undefined' : (0, _typeof3.default)(body)) === 'object' && body !== undefined && contentType === undefined) {
    contentType = 'application/json';
  }
  if (Object.keys(queryParameters).length > 0) {
    var queryParametersString = _qs2.default.stringify(queryParameters);
    var queryPrefix = url.includes('?') ? '&' : '?';
    url += '' + queryPrefix + queryParametersString;
  }
  var _map = [[requestTransformers, REQUEST_TRANSFORMERS], [responseTransformers, RESPONSE_TRANSFORMERS], [errorTransformers, ERROR_TRANSFORMERS]].map(function (line) {
      return buildTransformer(line[0], line[1]);
    }),
    _map2 = (0, _slicedToArray3.default)(_map, 3),
    reqTransformers = _map2[0],
    resTransformers = _map2[1],
    errTransformers = _map2[2];
  if (contentType) {
    headers['content-type'] = contentType;
  }
  if (accept) {
    headers.accept = accept;
  }
  var options = {
    headers: headers,
    method: method,
    body: handleTransformer(contentType, reqTransformers, body),
    credentials: credentials,
    mode: mode,
    redirect: redirect,
    follow: follow,
    cache: cache,
    referrer: referrer,
    compress: compress,
    timeout: timeout,
    size: size,
    agent: agent
  };
  if (integrity) {
    options.integrity = integrity;
  }
  return (0, _retry2.default)(function () {
    return (0, _crossFetch2.default)(url, options);
  }, {
    max: retryMax,
    backoff: retryBackoff
  }).catch(function (error) {
    return new _ResponseError2.default({
      status: 0,
      text: error.message,
      response: error,
      url: url
    });
  }).then(function (response) {
    return checkStatus(response);
  }).then(function (response) {
    return handleTransformer(response.headers.get('content-type'), resTransformers, response);
  }).catch(function (error) {
    throw handleTransformer(error.status, errTransformers, error);
  });
}